<template>
  <b-alert :variant="type" :show="durations" :dismissible="close" style="opacity:0.85">
    <span>{{message}}</span>
  </b-alert>
  <!-- class="position-fixed fixed-top m-0 rounded-0 mt-5" -->
</template>
<script>
export default {
  data() {
    return {
      type: "",
      close: true,
      durations: 5,
      message: ""
    };
  }
};
</script>

<style>
</style>
